import { createApi } from '@reduxjs/toolkit/query/react';

import { createApiBaseQuery, Methods } from '../shared';

import { AI_PROMPTS_CHUNK } from './const';
import {
  AiPromptsEndpoints as Endpoints,
  type GetAiPromptsRequest,
  type GetAiPromptsResponse,
  type SaveAiPromptsRequest,
  type SaveAiPromptsResponse,
  type GetDefaultAiPromptRequest,
  type GetDefaultAiPromptResponse,
} from './types';

const AI_PROMPTS_TAG = 'AiPrompts';

export const aiPromptsApi = createApi({
  reducerPath: 'aiPromptsApi',
  baseQuery: createApiBaseQuery(AI_PROMPTS_CHUNK),
  tagTypes: [AI_PROMPTS_TAG],
  endpoints: ({ query, mutation }) => ({
    [Endpoints.Get]: query<GetAiPromptsResponse, GetAiPromptsRequest>({
      query: (params) => ({
        url: Endpoints.Get,
        method: Methods.GET,
        params,
      }),
      providesTags: [AI_PROMPTS_TAG],
    }),
    [Endpoints.Save]: mutation<SaveAiPromptsResponse, SaveAiPromptsRequest>({
      query: ({ data, ...params }) => ({
        url: Endpoints.Save,
        method: Methods.PUT,
        params,
        data,
      }),
      invalidatesTags: [AI_PROMPTS_TAG],
    }),
    [Endpoints.GetDefault]: query<
      GetDefaultAiPromptResponse,
      GetDefaultAiPromptRequest
    >({
      query: (params) => ({
        url: Endpoints.GetDefault,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useGetAiPromptsQuery,
  useLazyGetAiPromptsQuery,
  useSaveAiPromptsMutation,
  useLazyGetDefaultAiPromptQuery,
} = aiPromptsApi;
